<div class="bg-white flex w-full max-w-lg flex-col items-center gap-2">
  <h1 class="text-h1 font-semibold text-text-primary">
    {{ 'perio_exam_intro_title' | translate }}
  </h1>
  <div class="flex flex-col items-center">
    <p class="text-h4 font-light text-text-primary">
      {{ 'perio_exam_intro_description_line1' | translate }}
    </p>
    <div class="flex items-center gap-0.5">
      <svg-icon key="px-16-voice" size="sm" class="text-states-purple"></svg-icon>
      <p class="text-h4 font-medium text-text-primary">
        {{ 'perio_exam_intro_voice_controls' | translate }}
      </p>
    </div>
    <p class="text-h4 font-light text-text-primary">
      {{ 'perio_exam_intro_description_line2' | translate }}
    </p>
  </div>
</div>
